/**
 * api/saudeDaExecucao.js — a aba "Saúde" do Live Board.
 *
 *   GET  /executions/{id}/saude              → { disponivel, resumo, etapas[], alertas[] }
 *   POST /executions/{id}/saude/diagnostico  → { classe, confianca, explicacao, evidencias[],
 *                                                recomendacao, proximo_passo, custo_usd, gerado_em }
 *
 * O diagnóstico usa IA (tem custo em US$ e pode levar até um minuto): só sob pedido.
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import { useApi } from './client';

export const saudeKey = (executionId) => ['executions', executionId, 'saude'];

/** Atualiza a cada `intervalo` (10 s) enquanto a execução roda; para quando ela encerra.
 *  Quem só precisa do selo de alertas (aba fechada) passa um intervalo maior. */
export function useSaudeDaExecucao(executionId, { intervalo = 10_000 } = {}) {
  const api = useApi();
  return useQuery({
    queryKey: saudeKey(executionId),
    queryFn:  () => api.get(`/executions/${executionId}/saude`),
    enabled:  Boolean(executionId),
    staleTime: 5_000,
    refetchInterval: (query) => (query.state.data?.resumo?.encerrada ? false : intervalo),
  });
}

export function useDiagnosticoDaSaude(executionId) {
  const api = useApi();
  return useMutation({
    // chamada de IA: a chave ['ai'] aciona o overlay de tela cheia do AppLayout (a página
    // fica coberta, com a animação, até a IA responder)
    mutationKey: ['ai'],
    meta: { aiLabel: 'A IA está validando esta execução…',
            aiSublabel: 'Lendo etapas, provas e alertas para dizer se o problema é da entrega, '
              + 'da plataforma ou do ambiente. Pode levar até um minuto.' },
    mutationFn: () => api.post(`/executions/${executionId}/saude/diagnostico`),
  });
}
